import ISection from '../models/ISection';
import AbstractCRUDService from './AbstractCRUDService';

class SectionService extends AbstractCRUDService<ISection> {}

export default new SectionService('management/section');
